/**
 * Quadro "Cuidados e IDSS" da ficha do beneficiário: como a pessoa está em
 * cada cuidado que conta para o IDSS (e a mamografia, fora dele), a facilidade
 * de converter e os alertas de cuidado. Só aparece para quem tem o módulo
 * Indicadores ANS (é informação de saúde).
 */
import React, { useEffect, useState } from 'react';
import { HeartPulse, AlertTriangle, CheckCircle2, Circle } from 'lucide-react';
import api from '../services/api';
import InfoTip from './InfoTip';

const COR_FAC = { Alta: ['#d1f2e0', '#11643b'], 'Média': ['#fff4cf', '#7a5a00'], Baixa: ['#eef1f4', '#55606b'] };

export default function CuidadosIdss({ cpf, cardStyle, tituloStyle }) {
  const [d, setD] = useState(null);
  const [falhou, setFalhou] = useState(false);
  useEffect(() => {
    let vivo = true;
    setD(null); setFalhou(false);
    api.get(`/indicadores-ans/beneficiario/${cpf}`)
      .then((r) => { if (vivo) setD(r.data); })
      .catch(() => { if (vivo) setFalhou(true); });
    return () => { vivo = false; };
  }, [cpf]);
  if (falhou || !d || (!d.itens.length && !d.alertas.length)) return null;
  return (
    <div style={cardStyle}>
      <div style={{ ...tituloStyle, display: 'flex', alignItems: 'center', gap: 6 }}>
        <HeartPulse size={14} />
        Cuidados e IDSS {d.ano}
        <InfoTip w={320} texto={`Como a pessoa está em cada cuidado que conta para o IDSS (regras do ano-base ${d.ano_fichas}) e na mamografia. ALTA/MÉDIA/BAIXA é a facilidade de converter: comece por quem falta só um passo. ${d.observacao}`} />
      </div>
      {d.alertas.map((a) => (
        <div key={a.codigo} style={{ display: 'flex', gap: 6, alignItems: 'flex-start', background: '#fff5f5', border: '1px solid #f5c6cb',
          borderRadius: 8, padding: '6px 8px', marginBottom: 6, fontSize: '0.78rem', color: '#8e1b1b' }}>
          <AlertTriangle size={14} style={{ flexShrink: 0, marginTop: 1 }} /> {a.texto}
        </div>
      ))}
      {d.itens.map((i) => {
        const ok = i.status === 'em_dia';
        const [bg, fg] = COR_FAC[i.facilidade] || [];
        return (
          <div key={i.codigo} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '6px 0', borderBottom: '1px solid #f0f0f0' }}>
            {ok ? <CheckCircle2 size={15} color="#27ae60" style={{ flexShrink: 0, marginTop: 1 }} />
                : <Circle size={15} color="#e67e22" style={{ flexShrink: 0, marginTop: 1 }} />}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '0.8rem', fontWeight: 600, color: '#2c3e50', display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                {i.nome}
                {i.fora_idss && <span style={{ fontSize: '0.65rem', color: '#7f8c8d', fontWeight: 400 }}>(fora do IDSS)</span>}
                <InfoTip w={300} texto={i.ajuda} />
              </div>
              <div style={{ fontSize: '0.75rem', color: ok ? '#27ae60' : '#5d6d7e' }}>{i.texto}</div>
            </div>
            {i.facilidade && (
              <span title="Facilidade de converter" style={{ background: bg, color: fg, borderRadius: 6, padding: '1px 7px', fontSize: '0.68rem', fontWeight: 600, flexShrink: 0 }}>
                {i.facilidade}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
